<template>
	<div >
		<el-input size="small" v-model="value" @input="updateValue"  :placeholder="'请输入' + info.fieIdName" :label="info.fieIdName"  ></el-input>
	</div>
</template>

<script>
	export default {
		data() {
			return {
			value: ''
			}
		},
		props: ['info','index'],
		mounted() {
			this.value = this.info.fieIdValue ? this.info.fieIdValue : ''
		},
		watch: {
			info: {
			    handler(newValue, oldValue) {
					this.value = newValue.fieIdValue
			    },
			    deep: true,
			}
		},
		methods: {
			updateValue(e){
				let obj = {
					type: 1,
					fieIdValue: this.value,
					fieIdId: this.info.fieIdId,
					index: this.index
				}
				this.$emit('updateValue',obj)
			}
		}
	}
</script>